import React from 'react';
import { Banner, mapToPageHeader } from '@components/Banner';
import { mapToSEO } from '@components/SEO';
import {
  SignupBannerWrapper,
  mapToKiwiVIPVisible,
} from '@components/SignupBanner';
import { ListingView } from '@components/Listings';
import { FaqList, mapToFaqContainer } from '@components/FaqList';
import theme from '@styles/theme';
import { GenericBannerContainer } from '@components/GenericBannerContainer';
import { data, LoaderFunction } from '@remix-run/node';
import { queryItemByCodeName } from '~/utils/kontentClientWrapper';
import { MarketplaceListings } from '~/_models';
import { useLoaderData } from '@remix-run/react';
import SEO from '~/components/SEO/SEO';
import { useClientEnv } from '~/contexts/ClientEnvContext';
export { headers } from '~/defaults.server';
export const loader: LoaderFunction = async ({ request }) => {
  const marketplacePage = await queryItemByCodeName<MarketplaceListings>(
    'marketplace',
    4,
  );

  return data<MarketplaceListings>(marketplacePage, {
    headers: {
      'Cache-Control': `public, max-age=${process.env.HTTP_CACHE_MAX_AGE || 300}, stale-while-revalidate=${process.env.STALE_WHILE_REVALIDATE || 3600}`,
    },
  });
};

const Marketplace = () => {
  const { elements } = useLoaderData<MarketplaceListings>();
  const clientEnv = useClientEnv();
  const seo = mapToSEO(elements);
  const kiwiVip = mapToKiwiVIPVisible(elements);
  const metadata = mapToPageHeader(elements);

  const faqs = mapToFaqContainer(
    elements.marketplaceFaqs.linkedItems[0].elements,
  );
  const header = elements.header.value;
  const description = elements.description.value;
  return (
    // <Layout location={props.location} authEnabled={true}>
    <>
      <SEO {...seo} />
      <Banner {...metadata} isBiggerBanner={false} />

      <ListingView
        apiUrl={clientEnv.apiUrl}
        header={header}
        description={description}
      />
      <GenericBannerContainer
        padding={{
          mobile: { top: 50, bottom: 60 },
          desktop: { top: 90, bottom: 100 },
        }}
        backgroundColor={faqs.backgroundColor}
      >
        <FaqList
          {...faqs}
          answerColor={theme.brand.colors.black}
          questionColor={theme.brand.colors.black}
          borderColor={theme.brand.colors.black}
        />
      </GenericBannerContainer>
      {kiwiVip.visible && <SignupBannerWrapper version={kiwiVip.version} />}
    </>

    // </Layout>
  );
};

export default Marketplace;
